import CouponList from '@/views/coupon/coupon-list.vue';
import CouponDetail from '@/views/coupon/coupon-detail.vue';

export default [
    {
        path: '/coupon/coupon-list',
        component: CouponList,
        name: 'couponList'
    },
    {
        path: '/coupon/coupon-detail',
        component: CouponDetail,
        name: 'couponDetail'
    },
]